// mds-dojo — dijit/_KeyNavContainer — FAITHFUL port of references/dijit/_KeyNavContainer.js.
// A _Container with keyboard navigation of its children (base for Menu/MenuBar/Toolbar).
// declare from the faithful runtime.
//
// mds ADAPTATIONS (behavior-preserving):
//  - `kernel.deprecated` is guarded (mds dojo/_base/kernel has no deprecated()).
//  - unused `dojo/dom-attr` import dropped.
import array from '../dojo/_base/array'; // array.forEach
import declare from '../dojo/_base/declare-runtime'; // declare
import kernel from '../dojo/_base/kernel'; // kernel.deprecated
import keys from '../dojo/keys'; // keys.END keys.HOME
import lang from '../dojo/_base/lang'; // lang.hitch
import registry from './registry';
import _Container from './_Container';
import _FocusMixin from './_FocusMixin';
import _KeyNavMixin from './_KeyNavMixin';

export default declare('dijit._KeyNavContainer', [_FocusMixin, _KeyNavMixin, _Container], {
  // summary:
  //		A _Container with keyboard navigation of its children.

  connectKeyNavHandlers: function (/*keys[]*/ prevKeyCodes: any, /*keys[]*/ nextKeyCodes: any) {
    // Deprecated.  You can call this in postCreate() to attach the keyboard handlers to
    // the container, but the preferred method is to override _onLeftArrow() and
    // _onRightArrow(), or _onUpArrow() and _onDownArrow(), to call focusPrev() and focusNext().

    var keyCodes: any = (this._keyNavCodes = {});
    var prev = lang.hitch(this, 'focusPrev');
    var next = lang.hitch(this, 'focusNext');
    array.forEach(prevKeyCodes, function (code: any) {
      keyCodes[code] = prev;
    });
    array.forEach(nextKeyCodes, function (code: any) {
      keyCodes[code] = next;
    });
    keyCodes[keys.HOME] = lang.hitch(this, 'focusFirstChild');
    keyCodes[keys.END] = lang.hitch(this, 'focusLastChild');
  },

  startupKeyNavChildren: function () {
    (kernel as any).deprecated && (kernel as any).deprecated('startupKeyNavChildren() call no longer needed', '', '2.0');
  },

  startup: function () {
    this.inherited(arguments);
    array.forEach(this.getChildren(), lang.hitch(this, '_startupChild'));
  },

  addChild: function (/*dijit/_WidgetBase*/ widget: any, /*int?*/ insertIndex?: any) {
    this.inherited(arguments);
    this._startupChild(widget);
  },

  _startupChild: function (/*dijit/_WidgetBase*/ widget: any) {
    // Setup for each child widget. Sets tabIndex=-1 on each child, so that the tab key
    // will leave the container rather than visiting each child.
    widget.set('tabIndex', '-1');
  },

  _getFirst: function () {
    // Returns the first child.
    var children = this.getChildren();
    return children.length ? children[0] : null;
  },

  _getLast: function () {
    // Returns the last descendant.
    var children = this.getChildren();
    return children.length ? children[children.length - 1] : null;
  },

  focusNext: function () {
    // Focus the next widget
    this.focusChild(this._getNextFocusableChild(this.focusedChild, 1));
  },

  focusPrev: function () {
    // Focus the last focusable node in the previous widget
    // (ex: go to the ComboButton icon section rather than button section)
    this.focusChild(this._getNextFocusableChild(this.focusedChild, -1), true);
  },

  childSelector: function (/*DOMNode*/ node: any) {
    // Implement _KeyNavMixin.childSelector, to identify focusable child nodes.
    var widget = registry.byNode(node);
    return widget && widget.getParent() == this;
  },
});
